import {createStyles, Theme} from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
    wrapLogin: {
        width: 'auto',
        display: 'block',
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto'
        }
    },
    title: {
        marginTop: '10vh',
        marginBottom: '10vh'
    },
    wrappBtn: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
    },
    googleButton: {
        marginRight: '30px'
    },
    button: {
        margin: theme.spacing()
    }
});

export default styles;
